// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coords_select.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot{box-shadow:none;padding:0}.coords_select.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot .v-select__selection--comma{overflow:visible;text-overflow:unset}.coords_select .v-input__control{height:50px;width:217px}.coords_select .v-label{overflow:visible;text-overflow:unset}", ""]);
// Exports
module.exports = exports;
